import {
  type EventPayload,
  type PlacedSign,
  type Unit,
  type UnitStatus,
  signById,
} from '@orgsim/shared';
import { useEffect, useState } from 'react';
import { Icon } from '../Icon';
import { UNIT_STATUS_LABELS } from '../labels';

export function SignDetails({
  sign,
  unit,
  readOnly,
  dispatch,
  onRemove,
}: {
  sign: PlacedSign;
  unit?: Unit;
  readOnly: boolean;
  dispatch: (payload: EventPayload) => void;
  onRemove: () => void;
}) {
  const [label, setLabel] = useState(sign.label ?? '');
  useEffect(() => setLabel(sign.label ?? ''), [sign.label]);
  return (
    <div className="sign-details">
      <div className="object-identity">
        <Icon name={unit ? 'truck' : 'pin'} size={24} />
        <div>
          <h3>{sign.label || signById(sign.signType).label}</h3>
          <p>{signById(sign.signType).label}</p>
        </div>
      </div>
      {unit ? (
        <section>
          <h4>Status</h4>
          <div className="unit-status-options">
            {(Object.keys(UNIT_STATUS_LABELS) as UnitStatus[]).map((status) => (
              <button
                key={status}
                type="button"
                disabled={readOnly}
                aria-pressed={unit.status === status}
                onClick={() => dispatch({ type: 'UnitStatusChanged', unitId: unit.id, status })}
              >
                {UNIT_STATUS_LABELS[status]}
              </button>
            ))}
          </div>
        </section>
      ) : null}
      {!readOnly ? (
        <>
          <p className="panel-description">
            Ziehe das Zeichen auf der Karte an seine neue Position.
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (label.trim())
                dispatch({
                  type: 'SignPlaced',
                  signId: sign.id,
                  signType: sign.signType,
                  position: sign.position,
                  label: label.trim(),
                  organisation: sign.organisation,
                });
            }}
          >
            <label htmlFor="sign-label">Beschriftung</label>
            <div className="button-group">
              <input id="sign-label" value={label} onChange={(e) => setLabel(e.target.value)} />
              <button
                type="submit"
                className="button"
                disabled={!label.trim() || label.trim() === sign.label}
              >
                Ändern
              </button>
            </div>
          </form>
          <button
            type="button"
            className="button danger-subtle"
            onClick={() => {
              dispatch({ type: 'SignRemoved', signId: sign.id });
              onRemove();
            }}
          >
            <Icon name="trash" size={15} />
            Von Karte entfernen
          </button>
        </>
      ) : null}
    </div>
  );
}
